import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enMaldives from './locales/en/maldives.json';
import enSafari from './locales/en/safari.json';

import ruCommon from './locales/ru/common.json';
import ruHome from './locales/ru/home.json';
import ruMaldives from './locales/ru/maldives.json';
import ruSafari from './locales/ru/safari.json';

export const supportedLngs = ['en', 'ru'] as const;
export type AppLanguage = typeof supportedLngs[number];

export const LANGUAGE_STORAGE_KEY = 'xplorius-lang';

const getInitialLanguage = (): AppLanguage => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored === 'en' || stored === 'ru') return stored;
  } catch {
    // localStorage unavailable (SSR/private mode) — fall through
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2).toLowerCase() : 'en';
  return nav === 'ru' ? 'ru' : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'maldives', 'safari'],
    supportedLngs: [...supportedLngs],
    resources: {
      en: { common: enCommon, home: enHome, maldives: enMaldives, safari: enSafari },
      ru: { common: ruCommon, home: ruHome, maldives: ruMaldives, safari: ruSafari },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
